import { I18n } from '@calendly/i18n'

// i18n-tasks-use t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.hours')
export const getSummary = ({ spotStep, customSpotStep, customSpotStepType }) => {
  if (spotStep === 'custom' && !customSpotStep) {
    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.not_set')
  }

  if (spotStep === 'custom' && customSpotStep) {
    return I18n.t(`publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.${customSpotStepType}`,
      { step: customSpotStep })
  }

  return I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.minutes',
    { step: spotStep })
}
